import { render, staticRenderFns } from "./UpdateVirtualDomainModal.vue?vue&type=template&id=24f6e18a&"
import script from "./UpdateVirtualDomainModal.vue?vue&type=script&lang=js&"
export * from "./UpdateVirtualDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports